import type { PickAnalyticsEventAttributes } from '../../../../types'
import { analyticsEvents } from '../../integration/analytics-multiplatform-sdk'

export const PhoneVerificationCallRequested = (
  attributes: PickAnalyticsEventAttributes<'PhoneVerificationCallRequested'>
) => {
  const { PhoneVerificationCallRequested } = analyticsEvents

  return new PhoneVerificationCallRequested(attributes.phone, attributes.origin)
}

export const PhoneVerificationEnterCode = (
  attributes: PickAnalyticsEventAttributes<'PhoneVerificationEnterCode'>
) => {
  const { PhoneVerificationEnterCode } = analyticsEvents

  return new PhoneVerificationEnterCode(attributes.phone, attributes.origin)
}

export const PhoneVerificationFailed = (
  attributes: PickAnalyticsEventAttributes<'PhoneVerificationFailed'>
) => {
  const { PhoneVerificationFailed } = analyticsEvents

  return new PhoneVerificationFailed(
    attributes.phone,
    attributes.reason,
    attributes.errorCode,
    attributes.errorMessage,
    attributes.origin
  )
}

export const PhoneVerificationStarted = (
  attributes: PickAnalyticsEventAttributes<'PhoneVerificationStarted'>
) => {
  const { PhoneVerificationStarted } = analyticsEvents

  return new PhoneVerificationStarted(attributes.phone, attributes.origin)
}

export const PhoneVerified = (attributes: PickAnalyticsEventAttributes<'PhoneVerified'>) => {
  const { PhoneVerified } = analyticsEvents

  return new PhoneVerified(attributes.phone, attributes.wasInUse, attributes.origin)
}
